import { ApplicationConfig, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app.routes';
import CustomTheme from './themes/customTheme';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { errorInterceptor } from '@core/interceptors/error.interceptor';
import { AuthInterceptor } from '@core/interceptors/auth.interceptor';
import { mobileInterceptor } from '@core/interceptors/mobile.interceptor';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { forkJoin, map, Observable } from 'rxjs';
import { TRANSLATIONFILE } from '@core/utils/const';
import { ActivityWizardStore } from './pages/features/distribuzione-censimento/attivita/activity-wizard';
import { MobileTranslationLoader } from '@core/services/translation-loader.service';

// questa funzione prende tutti i file all'interno delle cartelle lingue (/assets/i18n)
// e li unisce in un unico file .json
// così facendo possiamo organizzare meglio le traduzioni per feature o shared
export function HttpLoaderFactory(http: HttpClient) {
  return new class implements TranslateLoader {
    getTranslation(lang: string): Observable<any> {
      const domains = TRANSLATIONFILE;  // Elenco dei domini da caricare
      const translationObservables = domains.map(domain => {
        return http.get(`/assets/i18n/${lang}/${domain}.json`);
      });

      return forkJoin(translationObservables).pipe(
        // le traduzioni vengono unite in un unico file
        map((translations: any[]) => {
          return translations.reduce((acc: any, translation) => {
            return { ...acc, ...translation };
          }, {});
        }),
      );
    }
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(
      withInterceptors([mobileInterceptor, errorInterceptor, AuthInterceptor])
    ),
    MessageService,
    DialogService,
    provideRouter(routes),
    provideAnimationsAsync(),
    providePrimeNG({
      translation: {
        dayNames: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
        dayNamesShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
        dayNamesMin: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
        monthNames: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
        monthNamesShort: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
        firstDayOfWeek: 1,
        today: 'Oggi',
        clear: 'Pulisci'
      },
      theme: {
        preset: CustomTheme,
        options: {
          darkModeSelector: false,
          cssLayer: { name: 'primeng', order: 'base, primeng, primeicons, utilities' },
        }
      }
    }),
    ActivityWizardStore,
    ConfirmationService,
    importProvidersFrom([
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useClass: MobileTranslationLoader
        }
      }),
    ]),

  ]
};
